import React from 'react';
import { Link } from '@landr/maestro';
import { LinkProps } from '@landr/maestro';
import { PrismicLinkTypes } from 'components/Slices/enums';
import { PrismicLinkFieldType, SliceContext } from 'components/Slices/types';
import { InternalLink } from 'components/InternalLink';
import { ExternalLink } from 'components/ExternalLink';

export interface PrismicLinkProps extends LinkProps {
    label?: string | null;
    link: PrismicLinkFieldType;
    className?: string;
    slice?: SliceContext;
    useMaestro?: boolean;
}

export const PrismicLink: React.FC<PrismicLinkProps> = ({ children, link, ...props }) => {
    if (!link) {
        return null;
    }

    if (link._linkType === PrismicLinkTypes.internal) {
        return (
            <InternalLink link={link} maestroComponent={Link} {...props}>
                {children}
            </InternalLink>
        );
    }

    return (
        <ExternalLink link={link} maestroComponent={Link} {...props}>
            {children}
        </ExternalLink>
    );
};
